export default __webpack_public_path__ + "static/media/autofactura.85ab9244.svg";